/* eslint-disable react-hooks/exhaustive-deps */
import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import { useEffect } from 'react'

import { useUser } from '../../utilities/hooks/useUser'
import { getUserDisplayInfo } from '../tradebuilder-v2/util/user'
import { GapRiskLayout } from './layout/gap-risk-layout'
import { actions as rawActions } from './state/gap-risk-slice'
import { useAppSelector } from './store/hooks'
import { useActions } from './store/use-actions'

const GapRiskWithContext = () => {
  const { data: user } = useUser()
  const riskActions = useActions(rawActions)
  const state = useAppSelector(state => state.gapRisk)
  const currentUser = user
  const userInfo = getUserDisplayInfo(currentUser)

  useEffect(() => {
    riskActions.init(userInfo)
  }, [])

  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={<GapRiskLayout isLoading={state.isLoading} />}
      topBarElement={<UserMenuTopBar />}
    />
  )
}

export const GapRiskPage = () => <GapRiskWithContext />

export default GapRiskPage
